import * as React from 'react';
import { useCallback, useImperativeHandle, useMemo, useState } from 'react';

import type { Event } from 'components/events/events/types';
import type { EventActionComponentProps } from 'views/types';
import MenuItem from 'components/bootstrap/menuitem/MenuItem';
import SetOwnerBulk from 'security-app/components/SecurityEvents/Alerts/AlertsModals/UsersModal/SetOwnerBulk';

interface Modal {
  toggle: () => void;
}

type Props = {
  events: Array<Event>;
};

export const BulkSetOwnerModal: React.ComponentType<Props & { ref: React.LegacyRef<Modal> }> = React.forwardRef<
  Modal,
  Props
>(({ events }, ref) => {
  const [showModal, setShowModal] = useState(false);
  const eventIds = useMemo(() => events.map((event) => event.id), [events]);
  const onClose = useCallback(() => setShowModal(false), []);

  useImperativeHandle(ref, () => ({
    toggle: () => setShowModal(true),
  }));

  return <SetOwnerBulk eventIds={eventIds} onClose={onClose} show={showModal} />;
});

export const BulkSetOwnerAction = ({ modalRef }: EventActionComponentProps<Modal>) => {
  const onClick = useCallback(() => modalRef().toggle(), [modalRef]);

  return <MenuItem onClick={onClick}>Set Owner</MenuItem>;
};
